import React, { Component } from "react";
import axios from "axios";
import { constantApp } from "../../../../config/constant";
import PropTypes from "prop-types";

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idNews: this.props.idNews,
      data: [],
    };
  }

  componentDidMount = async () => {
    const url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/News/NewsImages.php`;

    const param = {
      idNews: this.state.idNews,
    };
    let data = await axios
      .post(url, param)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {});
    if (data !== undefined && data.length > 0) {
      this.setState({ data });
    }
  };

  render() {
    return (
      <div id="myCarousel" className="carousel slide" data-ride="carousel">
        <ol className="carousel-indicators">
          {this.state.data.length > 1 &&
            this.state.data.map((item) => {
              return (
                <li
                  key={item.idImage}
                  data-target="#myCarousel"
                  data-slide-to={item.idImage}
                  className={item.idImage === "1" ? "active" : null}
                ></li>
              );
            })}
        </ol>

        <div className="carousel-inner">
          {this.state.data.map((item, index) => {
            return (
              <div
                key={item.idImage}
                className={index === 0 ? "item active" : "item"}
              >
                {/* <img src={constantApp.SERVERIP + `/assets/images/news-details/news` + this.state.idNews + `/` + item.Path} alt='' role='presentation' /> */}
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/assets/images/news-details/news` +
                    this.state.idNews +
                    `/` +
                    item.Path
                  }
                  alt=""
                  role="presentation"
                />
              </div>
            );
          })}
        </div>

        {this.state.data.length > 1 && (
          <>
            <a
              className="right carousel-control"
              href="#myCarousel"
              data-slide="prev"
            >
              <span
                className="glyphicon glyphicon-chevron-left"
                style={{ color: "#00a693" }}
              ></span>
            </a>
            <a
              className="left carousel-control"
              href="#myCarousel"
              data-slide="next"
            >
              <span
                className="glyphicon glyphicon-chevron-right"
                style={{ color: "#00a693" }}
              ></span>
            </a>
          </>
        )}
      </div>
    );
  }
}

Slider.propTypes = {
  idNews: PropTypes.string.isRequired,
};

export default Slider;
